"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDateTime = void 0;
var formatDateTime = exports.formatDateTime = function formatDateTime(date) {
  return new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
    timeZone: "America/New_York",
    // Para EDT/EST
    hour12: false
  }).format(date).replace(/(\d{2})\/(\d{2})\/(\d{4}), (\d{2}:\d{2}) (.+)/, "$3-$1-$2 $4 $5");
};